import React, { useContext, useEffect, useState, useCallback } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { InlineWidget } from "react-calendly";
import { useHistory } from "react-router-dom";
import { FormContext } from "../util/context";
import base from "../util/base";

const BookAppt2 = () => {
  const history = useHistory();
  const [form, setForm] = useContext(FormContext);
  const [id, setId] = useState();
  useEffect(() => {
    base("Users")
      .select({
        view: "Grid view",
        filterByFormula: `{Email} = '${form.email}'`,
      })
      .firstPage(function (err, records) {
        if (err) {
          console.error(err);
          return;
        }
        records.forEach(function (record) {
          setId(record.id);
        });
      });
  }, [form.email]);

  const sendRequest = useCallback(async () => {
    if (id) {
      base("Users").update(
        id,
        {
          "Booked First Appointment": "Yes",
        },
        function (err, record) {
          if (err) {
            console.error(err);
            return;
          }
          console.log(record.get("Email"));
          history.push("/dashboard");
        }
      );
    } else {
      history.push("/dashboard");
    }
  }, [id, history]);
  return (
    <Box mt={3} sx={{ justifyContent: "center" }}>
      <Typography align="center" variant="h4">
        Thanks for filling out the Biometrics Form
      </Typography>
      <Typography align="center" variant="subtitle1">
        To get started with your first assessment book an appointment below.
        After check your email for appointment details.
      </Typography>

      <InlineWidget url="https://calendly.com/nayelimarcial_parados" />
      <Box textAlign="center" mt={3}>
        <Button variant="contained" color="primary" onClick={sendRequest}>
          I booked my appointment!
        </Button>
      </Box>
      <Box textAlign="center" mt={3}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            history.push("/dashboard");
          }}
        >
          Skip for now
        </Button>
      </Box>
    </Box>
  );
};

export default BookAppt2;
